<template>
  <div class="py-video-container">
    <!-- 顶部导航栏 -->
    <div class="nav-bar">
      <div class="back-btn" @click="goBack">
        <i
          class="el-icon-arrow-left back-icon"
          style="font-size: 20px;font-weight: 600;"
        />
      </div>
      <div class="nav-title">复刻配音</div>
      <div class="nav-actions">
        <!-- 保留空位，与左侧返回按钮平衡 -->
      </div>
    </div>

    <!-- 主界面 -->
    <div v-if="currentStep === 1" class="main-content">
      <div class="text-input-section">
        <textarea
          v-model="scriptText"
          placeholder="请输入您需要配音的文案，至少15个字。"
          class="script-textarea"
          minlength="15"
        ></textarea>
      </div>
      <div class="voice-section">
        <div class="section-title">我的声音</div>
        <div class="saved-voice-item" v-if="savedVoice">
          <div class="voice-play-btn" @click="playSavedRecording" :class="{ loading: isLoadingAudio }">
            <i v-if="isLoadingAudio" class="el-icon-loading" style="font-size: 18px;"></i>
            <i v-else-if="isPlaying" class="el-icon-video-pause" style="font-size: 18px;"></i>
            <i v-else class="el-icon-video-play" style="font-size: 18px;"></i>
          </div>
          <div class="voice-details">
            <div class="voice-name">{{ savedVoice.name }}</div>
            <div class="voice-meta">
              <span class="voice-duration">{{ savedVoice.duration }}秒</span>
              <span class="voice-time">{{ savedVoice.time }}</span>
            </div>
          </div>
          <!-- <div class="voice-edit-btn">
            <i class="el-icon-edit" style="font-size: 18px;"></i>
          </div> -->
          <div class="voice-select">
            <i class="el-icon-check" style="font-size: 18px;"></i>
          </div>
          <div class="voice-added">已添加</div>
        </div>
        <div v-else class="voice-item" @click="currentStep = 2">
          <div class="voice-icon">
            <img src="../../assets/video/microphone-blue.png" alt="我的声音" />
            <!-- 备注：实际使用时需要将文件重命名为microphone-blue.png -->
          </div>
          <div class="voice-name">我的声音</div>
        </div>
        <div class="create-voice-link" @click="currentStep = 2" v-if="savedVoice">去创建新声音</div>
      </div>
    </div>

    <!-- 声音复刻须知界面 -->
    <div v-else-if="currentStep === 2" class="guide-content">
      <div class="guide-overlay" @click="currentStep = 1"></div>
      <div class="guide-modal">
        <div class="guide-title">声音复刻须知</div>
        <div class="guide-list">
          <div class="guide-item">
            <span class="guide-number">1.</span>
            <span class="guide-text">音频时长10-30秒</span>
          </div>
          <div class="guide-item">
            <span class="guide-number">2.</span>
            <span class="guide-text"
              >在安静的环境下录音，确保周围没有其他声音干扰，智能有一个人说话</span
            >
          </div>
          <div class="guide-item">
            <span class="guide-number">3.</span>
            <span class="guide-text">保持正常语速，清晰发音，避免背景噪音</span>
          </div>
          <div class="guide-item">
            <span class="guide-number">4.</span>
            <span class="guide-text">录音过程中请勿移动设备或遮挡麦克风</span>
          </div>
          <div class="guide-item">
            <span class="guide-number">5.</span>
            <span class="guide-text"
              >请确保您的声音清晰可辨，避免沙哑或含糊不清</span
            >
          </div>
        </div>
        <el-button type="primary" class="start-btn" @click="currentStep = 3"
          >开始录制</el-button
        >
      </div>
    </div>

    <!-- 录音界面 -->
    <div v-else-if="currentStep === 3" class="recording-content">
      <div class="recording-overlay" @click="currentStep = 1"></div>
      <div class="recording-modal">
        <div class="recording-title">录音中，请朗诵</div>
        <div class="recording-tip">
          <span style="color: #409eff;">请在安静的环境下，朗诵以下内容：</span>
        </div>
        <div class="recording-script">
          我是一段朗诵内容，我是一段朗诵内容，我是一段朗诵内容，我是一段朗诵内容，我是一段朗诵内容，我是一段朗诵内容，我是一段朗诵内容，我是一段朗诵内容，我是一段朗诵内容。
        </div>
        <div class="recording-status">
          <div>开始录音中</div>
          <div class="recording-controls">
            <div class="recording-time">{{ recordingSeconds }}</div>
            <div class="control-buttons">
              <div class="control-btn cancel" @click="stopRecording">
                <i class="el-icon-close" style="font-size: 20px;"></i>
              </div>
              <div class="control-btn confirm" @click="finishRecording">
                <i class="el-icon-check" style="font-size: 20px;"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部合成按钮 -->
    <div v-if="currentStep === 1" class="bottom-btn-section">
      <el-button
        type="primary"
        class="synthesize-btn"
        :disabled="scriptText.length < 15"
        @click="synthesizeAudio"
      >
        合成音频
      </el-button>
    </div>

    <!-- 复刻成功弹框 -->
    <div v-else-if="currentStep === 4" class="success-modal-overlay">
      <div class="success-modal">
        <div class="success-icon">
          <div class="success-check"></div>
        </div>
        <div class="success-title">复刻成功！</div>
        
        <!-- 音色信息和播放区域 -->
        <div class="voice-info-section">
          <div class="voice-item">
            <div class="voice-play-btn" @click="playRecording" :class="{ loading: isLoadingAudio }">
              <i v-if="isLoadingAudio" class="el-icon-loading" style="font-size: 18px;"></i>
              <i v-else-if="isPlaying" class="el-icon-video-pause" style="font-size: 18px;"></i>
              <i v-else class="el-icon-video-play" style="font-size: 18px;"></i>
            </div>
            <div class="voice-details">
              <div class="voice-name">{{ voiceColorName }}</div>
              <div class="voice-meta">
                <span class="voice-duration">{{ voiceColorDuration }}秒</span>
                <span class="voice-time">{{ voiceColorTime }}</span>
              </div>
            </div>
            <div class="voice-edit-btn">
              <i class="el-icon-edit" style="font-size: 18px;"></i>
            </div>
          </div>
        </div>

        <!-- 操作按钮 -->
        <div class="success-actions">
          <el-button class="re-record-btn" @click="reRecord">重新录制</el-button>
          <el-button type="primary" class="save-btn" @click="saveVoiceColor">保存音色</el-button>
        </div>
      </div>
    </div>

    <!-- 音频播放器（隐藏） -->
    <audio ref="audioPlayer" :src="audioUrl" controls style="display: none;"></audio>
  </div>
</template>

<script>
import axios from "axios";
import { workUpload,anchorVideoChatVoiceGenerateVoice } from '../../api/video';

export default {
  name: "PyVideo",
  data() {
    return {
      currentStep: 1, // 1: 主界面, 2: 声音复刻须知, 3: 录音界面, 4: 录音成功弹框
      scriptText: "",
      recordingSeconds: 0,
      recordingTimer: null,
      mediaRecorder: null,
      audioChunks: [],
      audioBlob: null,
      showSuccessModal: false, // 复刻成功弹框显示状态
      audioUrl: null, // 录音播放URL
      voiceColorName: '音色1', // 音色名称
      voiceColorDuration: 58, // 音色时长（秒）
      voiceColorTime: '2025-6-26 10:54:13', // 音色创建时间
      savedVoice: null, // 保存的录音信息
      audioId: null, // 录音ID
      isPlaying: false, // 是否正在播放
      isLoadingAudio: false, // 音频加载状态
      localAudioUrl: null, // 本地录音URL
      isConvertingAudio: false, // 是否正在转换音频格式
    };
  },
  watch: {
    currentStep(newStep) {
      // 当进入录音界面时自动开始录音
      if (newStep === 3) {
        this.startRecording();
      }
    },
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    async startRecording() {
      try {
        // 获取用户媒体设备
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: true,
        });

        // 创建媒体记录器
        this.mediaRecorder = new MediaRecorder(stream);
        this.audioChunks = [];

        // 开始计时
        this.recordingSeconds = 0;
        this.recordingTimer = setInterval(() => {
          this.recordingSeconds++;
          if (this.recordingSeconds >= 30) {
            this.finishRecording();
          }
        }, 1000);

        // 监听数据可用事件
        this.mediaRecorder.ondataavailable = (event) => {
          if (event.data.size > 0) {
            this.audioChunks.push(event.data);
          }
        };

        // 监听停止事件
        this.mediaRecorder.onstop = () => {
          // 创建音频Blob对象，使用浏览器自动检测的 MIME 类型
          const mimeType = this.mediaRecorder.mimeType || 'audio/webm';
          this.audioBlob = new Blob(this.audioChunks, { type: mimeType });

          console.log('录音数据：', this.audioBlob);

          // 创建本地录音URL用于播放
          if (this.localAudioUrl) {
            URL.revokeObjectURL(this.localAudioUrl);
          }
          this.localAudioUrl = URL.createObjectURL(this.audioBlob);

          // 停止所有音频轨道
          stream.getTracks().forEach((track) => track.stop());
        };

        // 开始录音
        this.mediaRecorder.start();
      } catch (error) {
        console.error("开始录音失败:", error);
        this.$message.error("无法访问麦克风，请检查权限设置");
        this.currentStep = 1;
      }
    },
    stopRecording() {
      // 停止录音逻辑
      if (this.recordingTimer) {
        clearInterval(this.recordingTimer);
        this.recordingTimer = null;
      }

      // 停止媒体记录器
      if (this.mediaRecorder && this.mediaRecorder.state !== "inactive") {
        this.mediaRecorder.stop();
      }

      // 重置状态
      this.audioChunks = [];
      this.recordingSeconds = 0;
      this.currentStep = 1;
    },
    
    // 播放录音
    async playRecording() {
      if (!this.localAudioUrl) {
        this.$message.error('录音文件不存在');
        return;
      }
      
      const audio = this.$refs.audioPlayer;
      
      if (this.isPlaying) {
        // 如果正在播放，则暂停
        audio.pause();
        this.isPlaying = false;
        return;
      }
      
      this.isLoadingAudio = true;
      
      try {
        // 移除之前的事件监听器
        audio.removeEventListener('canplay', this.handleCanPlay);
        audio.removeEventListener('ended', this.handleAudioEnded);
        audio.removeEventListener('error', this.handleAudioError);
        
        // 使用本地录音URL
        audio.src = this.localAudioUrl;
        
        // 等待音频加载完成
        audio.load();
        
        // 添加事件监听器
        audio.addEventListener('canplay', this.handleCanPlay);
        audio.addEventListener('ended', this.handleAudioEnded);
        audio.addEventListener('error', this.handleAudioError);
        
      } catch (error) {
        this.isLoadingAudio = false;
        console.error('播放录音失败:', error);
        this.$message.error('播放录音失败，请重试');
      }
    },
    
    // 处理音频可以播放事件
    handleCanPlay() {
      this.isLoadingAudio = false;
      this.$refs.audioPlayer.play();
      this.isPlaying = true;
    },
    
    // 处理音频播放结束事件
    handleAudioEnded() {
      this.isPlaying = false;
    },
    
    // 处理音频播放错误事件
    handleAudioError(e) {
      this.isLoadingAudio = false;
      this.isPlaying = false;
      console.error('音频播放错误:', e);
      this.$message.error('音频播放失败，请重试');
    },
    
    // 重新录制
    reRecord() {
      // 隐藏弹框
      this.currentStep = 2
      
      // 释放本地音频URL
      if (this.localAudioUrl) {
        URL.revokeObjectURL(this.localAudioUrl);
        this.localAudioUrl = null;
      }
      
      // 释放服务器音频URL（仅当是blob URL时）
      if (this.audioUrl && this.audioUrl.startsWith('blob:')) {
        URL.revokeObjectURL(this.audioUrl);
      }
      this.audioUrl = null;
      
      // 重置状态
      this.audioChunks = [];
      this.recordingSeconds = 0;
      this.audioBlob = null;
      this.isPlaying = false;
      this.isLoadingAudio = false;
      
      // 回到录音界面
      // this.currentStep = 3;
    },
    
    // 合成音频
    async synthesizeAudio() {
      if (!this.audioId) {
        this.$message.error('请先保存音色');
        return;
      }
      
      
        // this.$loading.show();
        const response = await anchorVideoChatVoiceGenerateVoice({
          voiceId: this.audioId,
          text: this.scriptText,
          userId: localStorage.getItem("userMes") ? (eval('(' + localStorage.getItem("userMes") + ')').phone) : "",
        });

        console.log('合成音频成功386:', response.data);
        
        // 接口成功后跳转到kbVideo页面
        this.$router.push({
          path: '/kbVideo',
          query: {
            text: this.scriptText,
            voiceId: response.data.data.id
          }
        });
      
    },
    
    // 保存音色
    saveVoiceColor() {
      // 隐藏弹框
      this.currentStep = 1;
      
      // 保存录音信息到savedVoice状态
      this.savedVoice = {
        name: this.voiceColorName,
        duration: this.voiceColorDuration,
        time: this.voiceColorTime,
        fileUrl: this.audioUrl
      };
      
      // 释放音频URL（仅当是blob URL时）
      if (this.audioUrl && this.audioUrl.startsWith('blob:')) {
        URL.revokeObjectURL(this.audioUrl);
      }
      this.audioUrl = null;
      
      // 提示用户音色已保存
      this.$message({ message: "音色已保存", type: "success" });
    },
    
    // 播放保存的录音
    async playSavedRecording() {
      if (!this.savedVoice || !this.savedVoice.fileUrl) {
        this.$message.error('录音文件不存在');
        return;
      }
      
      const audio = this.$refs.audioPlayer;
      
      if (this.isPlaying) {
        // 如果正在播放，则暂停
        audio.pause();
        this.isPlaying = false;
        return;
      }
      
      this.isLoadingAudio = true;
      
      try {
        // 移除之前的事件监听器
        audio.removeEventListener('canplay', this.handleCanPlay);
        audio.removeEventListener('ended', this.handleAudioEnded);
        audio.removeEventListener('error', this.handleAudioError);
        
        // 设置音频URL
        this.audioUrl = this.savedVoice.fileUrl;
        
        // 等待DOM更新
        await this.$nextTick();
        
        // 确保音频播放器存在
        if (!audio) {
          throw new Error('音频播放器未找到');
        }
        
        // 设置音频源并加载
        audio.src = this.audioUrl;
        audio.load();
        
        // 添加事件监听器
        audio.addEventListener('canplay', this.handleCanPlay);
        audio.addEventListener('ended', this.handleAudioEnded);
        audio.addEventListener('error', this.handleAudioError);
        
      } catch (error) {
        this.isLoadingAudio = false;
        console.error('播放保存录音失败:', error);
        this.$message.error('播放录音失败，请重试');
      }
    },
    // 将音频转换为 WAV 格式
    async convertToWav(audioBlob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = async () => {
          try {
            const audioContext = new (window.AudioContext || window.webkitAudioContext)();
            const arrayBuffer = reader.result;
            
            // 解码音频数据
            const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
            
            // 将 AudioBuffer 转换为 WAV 格式
            const wavBlob = this.audioBufferToWav(audioBuffer);
            resolve(wavBlob);
          } catch (error) {
            reject(error);
          }
        };
        reader.onerror = reject;
        reader.readAsArrayBuffer(audioBlob);
      });
    },
    
    // 将 AudioBuffer 转换为 WAV Blob
    audioBufferToWav(buffer) {
      const numChannels = buffer.numberOfChannels;
      const sampleRate = buffer.sampleRate;
      const format = 1; // PCM
      const bitDepth = 16;
      
      let result;
      if (numChannels === 2) {
        result = this.interleave(buffer.getChannelData(0), buffer.getChannelData(1));
      } else {
        result = buffer.getChannelData(0);
      }
      
      return this.encodeWAV(result, numChannels, sampleRate, bitDepth);
    },
    
    // 交错左右声道数据
    interleave(inputL, inputR) {
      const length = inputL.length + inputR.length;
      const result = new Float32Array(length);
      let index = 0;
      let inputIndex = 0;
      
      while (index < length) {
        result[index++] = inputL[inputIndex];
        result[index++] = inputR[inputIndex];
        inputIndex++;
      }
      
      return result;
    },
    
    // 编码 WAV 数据
    encodeWAV(samples, numChannels, sampleRate, bitDepth) {
      const buffer = new ArrayBuffer(44 + samples.length * 2);
      const view = new DataView(buffer);
      
      // WAV 文件头
      this.writeString(view, 0, 'RIFF');
      view.setUint32(4, 36 + samples.length * 2, true);
      this.writeString(view, 8, 'WAVE');
      this.writeString(view, 12, 'fmt ');
      view.setUint32(16, 16, true);
      view.setUint16(20, 1, true);
      view.setUint16(22, numChannels, true);
      view.setUint32(24, sampleRate, true);
      view.setUint32(28, sampleRate * numChannels * 2, true);
      view.setUint16(32, numChannels * 2, true);
      view.setUint16(34, bitDepth, true);
      this.writeString(view, 36, 'data');
      view.setUint32(40, samples.length * 2, true);
      
      // 写入音频数据
      this.floatTo16BitPCM(view, 44, samples);
      
      return new Blob([view], { type: 'audio/wav' });
    },
    
    // 写入字符串
    writeString(view, offset, string) {
      for (let i = 0; i < string.length; i++) {
        view.setUint8(offset + i, string.charCodeAt(i));
      }
    },
    
    // 浮点数转 16 位 PCM
    floatTo16BitPCM(view, offset, samples) {
      for (let i = 0; i < samples.length; i++, offset += 2) {
        const s = Math.max(-1, Math.min(1, samples[i]));
        view.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
      }
    },
    
    async finishRecording() {
      // 停止计时
      if (this.recordingTimer) {
        clearInterval(this.recordingTimer);
        this.recordingTimer = null;
      }

      // 停止录音
      if (this.mediaRecorder && this.mediaRecorder.state !== "inactive") {
        this.mediaRecorder.stop();
      }

      // 显示上传中提示
      this.$message({ message: "正在上传录音...", type: "info" });

      // 等待录音完成并创建Blob
      await this.$nextTick();

      // 等待audioBlob被设置（最多等待2秒）
      let waitCount = 0;
      while (!this.audioBlob && waitCount < 20) {
        await new Promise(resolve => setTimeout(resolve, 100));
        waitCount++;
      }

      // 检查audioBlob是否存在
      if (!this.audioBlob) {
        console.error('录音数据未生成');
        this.$message.error('录音失败，请重试');
        this.currentStep = 1;
        return;
      }

      try {
        // 准备上传数据
        const formData = new FormData();
        const userId = localStorage.getItem("userMes") ? (eval('(' + localStorage.getItem("userMes") + ')').phone) : "";

        // 再次检查audioBlob是否存在，防止空值错误
        if (!this.audioBlob) {
          console.error('录音数据丢失，无法上传');
          this.$message.error('录音数据丢失，请重新录制');
          this.currentStep = 1;
          return;
        }

        // 获取音频文件的 MIME 类型
        let mimeType = this.audioBlob?.type || 'audio/webm';
        let audioBlob = this.audioBlob;
        
        // 检查是否为标准格式（wav、mp4、mp3、aac），如果不是则转换为 WAV
        const isStandardFormat = mimeType.includes('wav') || 
                                  mimeType.includes('mp4') || 
                                  mimeType.includes('mp3') || 
                                  mimeType.includes('aac');
        
        if (!isStandardFormat) {
          console.log('检测到非标准音频格式，正在转换为 WAV...');
          this.isConvertingAudio = true;
          // this.$message({ message: "正在转换音频格式...", type: "info" });
          
          try {
            audioBlob = await this.convertToWav(this.audioBlob);
            mimeType = 'audio/wav';
            console.log('音频格式转换完成');
          } catch (error) {
            console.error('音频格式转换失败:', error);
            // this.$message.error('音频格式转换失败，将使用原始格式上传');
            // 转换失败时使用原始格式
            audioBlob = this.audioBlob;
          } finally {
            this.isConvertingAudio = false;
          }
        }
        
        // 根据 MIME 类型确定文件扩展名
        let fileExtension = 'wav';
        if (mimeType.includes('wav')) {
          fileExtension = 'wav';
        } else if (mimeType.includes('mp4')) {
          fileExtension = 'mp4';
        } else if (mimeType.includes('mp3')) {
          fileExtension = 'mp3';
        } else if (mimeType.includes('aac')) {
          fileExtension = 'aac';
        }

        // 将录音Blob转换为File对象，使用实际的文件类型
        const audioFile = new File([audioBlob], `recording.${fileExtension}`, {
          type: mimeType,
        });

        // 添加到FormData
        formData.append("file", audioFile);
        formData.append("userId", userId);

        // 发送请求 - 使用video.js中的aiOralFindAll接口
        const response = await workUpload(formData);

        console.log(response.data.data.fileUrl,'---response---')

        // 处理响应
        if (response.data && response.data.data.fileUrl) {
          // 先释放之前的URL
          if (this.audioUrl && this.audioUrl.startsWith('blob:')) {
            URL.revokeObjectURL(this.audioUrl);
          }
          
          // 保存服务器返回的文件URL（用于保存到savedVoice）
          this.audioUrl = response.data.data.fileUrl;
          this.audioId = response.data.data.id;
          
          // 显示复刻成功弹框
          this.currentStep = 4
          
          // 更新音色信息
          this.voiceColorDuration = this.recordingSeconds;
          this.voiceColorTime = new Date().toLocaleString();
        } else {
          console.error("录音上传失败，服务器未返回文件URL 667");
          this.$message.error(
            "录音上传失败：" + (response.data.message || "未知错误")
          );
        }
      } catch (error) {
        console.error("上传录音失败673:", error);
        this.$message.error("录音上传失败，请重试");
      } finally {
        // 不自动重置状态，保留录音信息
      }
    },
  },
  mounted() {
    // 图片重命名建议映射
    this.imageRenameMap = {
      "check-circle-filled (Background).png": "check-circle.png",
      "close-circle-filled (Background).png": "close-circle.png",
      "编组 3.png": "microphone-blue.png",
      "1.Base基础／3.Icon图标／设置图标／settings.png": "settings.png",
      "1.Base基础／3.Icon图标／麦克风图标／microphone.png": "microphone.png",
    };
  },
  beforeDestroy() {
    // 清理定时器
    if (this.recordingTimer) {
      clearInterval(this.recordingTimer);
      this.recordingTimer = null;
    }
    
    // 停止录音
    if (this.mediaRecorder && this.mediaRecorder.state !== "inactive") {
      this.mediaRecorder.stop();
    }
    
    // 移除音频事件监听器
    const audio = this.$refs.audioPlayer;
    if (audio) {
      audio.removeEventListener('canplay', this.handleCanPlay);
      audio.removeEventListener('ended', this.handleAudioEnded);
      audio.removeEventListener('error', this.handleAudioError);
      audio.pause();
    }
    
    // 页面销毁前清理资源
    if (this.localAudioUrl) {
      URL.revokeObjectURL(this.localAudioUrl);
    }
    if (this.audioUrl && this.audioUrl.startsWith('blob:')) {
      URL.revokeObjectURL(this.audioUrl);
    }
  },
};
</script>

<style scoped>
.py-video-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: linear-gradient(180deg, #bcdeff 0%, #ffffff 100%);
}

/* 顶部导航栏 */
.nav-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  padding: 0 20px;
  /* background-color: #ffffff; */
  /* box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05); */
}

.back-btn {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.back-icon {
  width: 20px;
  height: 20px;
}

.nav-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

.nav-actions {
  width: 40px;
}

/* 主界面 */
.main-content {
  flex: 1;
  padding: 0px 20px 20px 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.text-input-section {
  background-color: #ffffff;
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.script-textarea {
  width: 100%;
  border: none;
  resize: none;
  font-size: 15px;
  color: #303133;
  line-height: 1.6;
  min-height: 120px;
  outline: none;
}

.script-textarea::placeholder {
  color: #909399;
}

.voice-section {
  background-color: #ffffff;
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.section-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 15px;
  padding-left: 4px;
}

.voice-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border: 2px solid #e4e7ed;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: rgba(216, 216, 216, 0.2);
}

.voice-item:hover {
  border-color: #409eff;
  background-color: #ecf5ff;
}

.voice-icon {
  width: 40px;
  height: 40px;
  background-color: #ecf5ff;
  /* border-radius: 50%; */
  display: flex;
  align-items: center;
  justify-content: center;
}

.voice-icon img {
  width: 40px;
  height: 40px;
}

.voice-name {
  font-size: 15px;
  color: #303133;
  font-weight: 500;
  text-align: left;
}

/* 已保存的音色样式 */
.saved-voice-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px;
    border: 2px solid #409eff;
    border-radius: 8px;
    background: #ecf5ff;
    margin-bottom: 10px;
    width: 100%;
    box-sizing: border-box;
    position: relative;
  }

.saved-voice-item .voice-play-btn {
  width: 40px;
  height: 40px;
  background-color: #409eff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
}

.saved-voice-item .voice-play-btn:hover {
  background-color: #66b1ff;
}

.saved-voice-item .voice-details {
  flex: 1;
  min-width: 0;
}

.saved-voice-item .voice-details .voice-name {
  font-size: 15px;
  color: #303133;
  font-weight: 500;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.saved-voice-item .voice-meta {
  font-size: 12px;
  color: #909399;
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.saved-voice-item .voice-duration {
  margin-right: 10px;
}

.saved-voice-item .voice-edit-btn {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #909399;
  margin-right: 0;
}

.saved-voice-item .voice-edit-btn:hover {
  color: #303133;
}

.saved-voice-item .voice-select {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #67c23a;
  }
  
  .saved-voice-item .voice-added {
    position: absolute;
    top: -8px;
    right: -8px;
    background-color: #409eff;
    color: white;
    font-size: 12px;
    padding: 2px 8px;
    border-radius: 10px;
    font-weight: 500;
  }

.create-voice-link {
  color: #409eff;
  font-size: 14px;
  cursor: pointer;
  text-align: center;
  margin-top: 10px;
  display: block;
}

/* 声音复刻须知界面 */
.guide-content {
  position: relative;
  flex: 1;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.guide-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.guide-modal {
  position: relative;
  width: 100%;
  background-color: #ffffff;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  padding: 25px 20px;
  box-shadow: 0 -8px 32px rgba(0, 0, 0, 0.2);
}

.guide-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  text-align: center;
  margin-bottom: 25px;
}

.guide-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 30px;
  background: #ecf1f6;
  border-radius: 32rpx;
  padding: 20px;
  width: 100%;
  /* height: 400px; */
}

.guide-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.guide-number {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  flex-shrink: 0;
}

.guide-text {
  font-size: 14px;
  color: #606266;
  line-height: 1.5;
  flex: 1;
  text-align: left;
}

.start-btn {
  width: 100%;
  height: 50px;
  font-size: 17px;
  border-radius: 25px;
  background-color: #409eff;
  border: none;
  font-weight: 500;
}

.start-btn:hover {
  background-color: #66b1ff;
}

/* 录音界面 */
.recording-content {
  position: relative;
  flex: 1;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.recording-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.recording-modal {
  position: relative;
  width: 100%;
  background-color: #ffffff;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  padding: 25px 20px;
  box-shadow: 0 -8px 32px rgba(0, 0, 0, 0.2);
}

.recording-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  text-align: center;
  margin-bottom: 15px;
}

.recording-tip {
  font-size: 14px;
  color: #606266;
  text-align: center;
  margin-bottom: 20px;
  line-height: 1.4;
}

.recording-script {
  background-color: #f5f7fa;
  border-radius: 10px;
  padding: 15px;
  font-size: 15px;
  color: #303133;
  line-height: 1.6;
  margin-bottom: 30px;
  min-height: 100px;
  border: 2px solid #e4e7ed;
  gap: 15px;
}
.recording-status {
  font-size: 20px;
  color: #606266;
  text-align: left;
  margin-bottom: 20px;
  line-height: 1.4;
  border-radius: 32rpx;
  padding: 20px 10px;
  border-radius: 20px;
  background: #ecf1f6;
}

.recording-controls {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.recording-time {
  font-size: 36px;
  font-weight: 600;
  color: #303133;
  font-family: monospace;
}

.control-buttons {
  display: flex;
  gap: 20px;
}

.control-btn {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.control-btn.cancel {
  background-color: #fef0f0;
  border: 2px solid #fbc4c4;
}

.control-btn.confirm {
  background-color: #f0f9eb;
  border: 2px solid #b3e19d;
}

.control-btn img {
  width: 24px;
  height: 24px;
}

.control-btn:hover {
  transform: scale(1.1);
}

/* 底部合成按钮 */
.bottom-btn-section {
  padding: 0px 20px 16px 20px;
  background-color: #ffffff;
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.05);
}

.synthesize-btn {
  width: 100%;
  height: 50px;
  font-size: 17px;
  border-radius: 25px;
  background-color: #409eff;
  border: none;
  font-weight: 500;
}

.synthesize-btn:hover:not(:disabled) {
  background-color: #66b1ff;
}

.synthesize-btn:disabled {
    background-color: #c0c4cc;
    cursor: not-allowed;
  }

  /* 复刻成功弹框样式 */
  .success-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: flex-end;
    justify-content: center;
    z-index: 1000;
  }

  .success-modal {
    background-color: white;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    padding: 32px 24px;
    width: 100%;
    box-shadow: 0 -8px 32px rgba(0, 0, 0, 0.1);
    text-align: center;
  }

  .success-icon {
    width: 80px;
    height: 80px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 24px;
    position: relative;
    overflow: hidden;
  }

  .success-icon::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
    opacity: 0.7;
  }

  .success-check {
    width: 20px;
    height: 40px;
    border-bottom: 4px solid white;
    border-right: 4px solid white;
    transform: rotate(45deg);
    z-index: 1;
  }

  .success-title {
    font-size: 24px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 24px;
  }

  .voice-info-section {
    background-color: #f5f7fa;
    border-radius: 12px;
    padding: 16px;
    margin-bottom: 24px;
    text-align: left;
  }

  .voice-item {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  /* 确保主界面的voice-item和success-modal中的voice-item样式不冲突 */
  .main-content .voice-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px;
    border: 2px solid #e4e7ed;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    background: rgba(216, 216, 216, 0.2);
  }

  .voice-play-btn {
  width: 40px;
  height: 40px;
  background-color: #409eff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
}

.voice-play-btn:hover {
  background-color: #66b1ff;
}

.voice-play-btn.loading {
  background-color: #909399;
  cursor: not-allowed;
}

.voice-play-btn.loading:hover {
  background-color: #909399;
}

  .voice-details {
    flex: 1;
  }

  .voice-name {
    font-size: 16px;
    font-weight: 500;
    color: #303133;
    margin-bottom: 4px;
  }

  .voice-meta {
    font-size: 14px;
    color: #909399;
    display: flex;
    gap: 12px;
  }

  .voice-edit-btn {
    color: #909399;
    cursor: pointer;
    transition: color 0.3s ease;
  }

  .voice-edit-btn:hover {
    color: #409eff;
  }

  .success-actions {
    display: flex;
    gap: 12px;
  }

  .success-actions .el-button {
    flex: 1;
    height: 44px;
    font-size: 16px;
    border-radius: 22px;
  }

  .re-record-btn {
    border: 1px solid #dcdfe6;
    color: #606266;
  }

  .save-btn {
    background-color: #409eff;
    border: none;
  }

  .save-btn:hover {
    background-color: #66b1ff;
  }
</style>
